// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"474":"985089d7","488":"ed171d09","583":"bf11a3e3","602":"2c2ad514"}[chunkId] + ".chunk.js";
};